var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0c-101.264 0-200.254 30.028-284.452 86.287s-149.822 136.223-188.574 229.779c-38.752 93.556-48.891 196.501-29.136 295.821s68.519 190.549 140.123 262.153c71.604 71.603 162.834 120.367 262.153 140.122s202.265 9.617 295.82-29.133c93.555-38.754 173.521-104.38 229.777-188.578 56.26-84.194 86.289-183.185 86.289-284.45-0.393-135.67-54.464-265.67-150.396-361.603-95.936-95.933-225.933-150.003-361.604-150.397v0zM426.667 742.997l-230.997-230.997 60.331-60.331 170.666 170.667 341.333-341.333 60.331 60.331-401.664 401.664z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.1e6a2f664fd34c35264c129dec5b8131.svg";
export { ForwardRef as ReactComponent };